import './Playlist.css'

const Playlist = () => {
    return (
        <div className="playlistVideos">
            <span className="playlistVideos_soonText">Coming Soon...</span>
        </div>
    )
}

export default Playlist;